import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import SignInForm from "../../components/forms/SignInForm";
import { signIn, authenticate } from "../../store/action/auth";
import ReactInterval from "react-interval";
import { identify, trackEvent } from "../../services/analytics";
import { Helmet } from "react-helmet";

const SignIn = () => {
  const [values, setValues] = useState({
    email: "",
    password: "",
    error: "",
    loading: false,
    redirectToReferrer: false,
  });

  const { email, password, error, redirectToReferrer } = values;

  const handleChange = (name) => (event) => {
    setValues({ ...values, error: false, [name]: event.target.value });
  };

  const onSubmit = (event) => {
    setValues({ ...values, error: false, loading: true });
    signIn({ email, password }).then((data) => {
      if (data.error) {
        setValues({ ...values, error: data.error, loading: false });
      } else {
        let user = {
          expired_at: data.expired_at || null,
          refreshToken: data.refresh_token || null,
          token: data.token,
          user: {
            _id: data.id,
            email: data.email,
            firstName: data.first_name,
            lastName: data.last_name,
            role: data.role,
            organizationName: data.organization_name,
            bankAccounts: data.bank_accounts,
            phone: data.phone,
            paymentStatus: data.payment_status,
            paymentDueDate: data.payment_due_date,
          },
        };

        trackEvent("User Sign In", {
          action: "track",
          category: "Users",
          label: "Sign In From Website",
          event: "Click",
        });

        authenticate(user, () => {
          identify(user.user._id, user);
          setValues({
            ...values,
            redirectToReferrer: true,
            loading: false,
          });
        });
      }
    });
  };

  const showError = () => (
    <div
      className="alert alert-danger"
      style={{ display: error ? "" : "none" }}
    >
      {error}
    </div>
  );

  const redirectUser = () => {
    if (redirectToReferrer) {
      return <Redirect to="/overview" />;
    }
  };

  const onLoading = (e) => {
    setValues({ ...values, loading: true });
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Biteship: Sign In</title>
        <meta
          name="description"
          content="Sign in to your account and start shipping!"
        />
        <link rel="canonical" href="https://dashboard.biteship.com/signin" />
      </Helmet>
      <ReactInterval
        timeout={2000}
        enabled={values.loading}
        callback={() => onSubmit()}
      />
      <div className="peers ai-s fxw-nw h-100vh">
        <div
          className="d-n@sm- peer peer-greed bgpX-c bgpY-c bgsz-cv pos-r"
          style={{
            backgroundImage: 'url("images/bg.jpg")',
            height: "100%!important",
            position: "relative!important",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div
          className="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-white scrollable pos-r"
          style={{ minWidth: "320px" }}
        >
          <h2 id="brand-logo">
            <a className="navbar-brand" id="header-logo">
              <img
                className="rounded-full"
                style={{ height: 72 }}
                src={"/images/logos/biteship.png"}
                alt=""
              />
            </a>
          </h2>
          {showError()}
          {redirectUser()}
          <SignInForm
            handleChange={handleChange}
            values={values}
            loading={values.loading}
            onSubmit={onLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
